"use client"

import { useTranslations } from "next-intl"

import { Pill } from "@/components/ui"
import type { FacetValue } from "@/lib/types/search"

const SWATCH_CLASS = {
  BLACK: "bg-swatch-black",
  WHITE: "bg-swatch-white",
  GRAY: "bg-swatch-gray",
  BEIGE: "bg-swatch-beige",
  BROWN: "bg-swatch-brown",
  RED: "bg-swatch-red",
  PINK: "bg-swatch-pink",
  ORANGE: "bg-swatch-orange",
  YELLOW: "bg-swatch-yellow",
  GREEN: "bg-swatch-green",
  BLUE: "bg-swatch-blue",
  NAVY: "bg-swatch-navy",
  PURPLE: "bg-swatch-purple",
  GOLD: "bg-swatch-gold",
  SILVER: "bg-swatch-silver",
  MULTICOLOR: "bg-swatch-multicolor",
} as const

type ColorName = keyof typeof SWATCH_CLASS

const isColorName = (value: string): value is ColorName => Object.hasOwn(SWATCH_CLASS, value)

interface ColorFacetProps {
  options: FacetValue[]
  selected: string[]
  onToggle: (value: string) => void
}

export const ColorFacet = ({ options, selected, onToggle }: ColorFacetProps) => {
  const t = useTranslations("search")

  return (
    <div className="flex flex-wrap gap-150">
      {options.map((option) => (
        <Pill
          key={option.value}
          tone="outline"
          size="xs"
          selected={selected.includes(option.value)}
          aria-label={t("facetOption", { label: option.label, count: option.count })}
          onClick={() => onToggle(option.value)}
        >
          {isColorName(option.value) && <span aria-hidden className={`border-line size-4 shrink-0 rounded-full border ${SWATCH_CLASS[option.value]}`} />}
          {option.label}
        </Pill>
      ))}
    </div>
  )
}
